import { Haptics, ImpactStyle, NotificationType } from '@capacitor/haptics';

let hapticsAvailable = false;

export async function initHaptics() {
  try {
    await Haptics.impact({ style: ImpactStyle.Light });
    hapticsAvailable = true;
  } catch {
    hapticsAvailable = false;
  }
}

export async function lightImpact() {
  if (!hapticsAvailable) return;
  try {
    await Haptics.impact({ style: ImpactStyle.Light });
  } catch {
    // ignore
  }
}

export async function mediumImpact() {
  if (!hapticsAvailable) return;
  try {
    await Haptics.impact({ style: ImpactStyle.Medium });
  } catch {
    // ignore
  }
}

export async function heavyImpact() {
  if (!hapticsAvailable) return;
  try {
    await Haptics.impact({ style: ImpactStyle.Heavy });
  } catch {
    // ignore
  }
}

export async function notificationSuccess() {
  if (!hapticsAvailable) return;
  try {
    await Haptics.notification({ type: NotificationType.Success });
  } catch {
    // ignore
  }
}

export async function notificationError() {
  if (!hapticsAvailable) return;
  try {
    await Haptics.notification({ type: NotificationType.Error });
  } catch {
    // ignore
  }
}
